import { render, staticRenderFns } from "./AccidentCount.vue?vue&type=template&id=69cd735c&scoped=true"
import script from "./AccidentCount.vue?vue&type=script&lang=js"
export * from "./AccidentCount.vue?vue&type=script&lang=js"
import style0 from "./AccidentCount.vue?vue&type=style&index=0&id=69cd735c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd735c",
  null
  
)

export default component.exports